import { render } from "./Imprint.vue?vue&type=template&id=5a45364e"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=5a45364e&lang=css"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__